import CheckoutListTable from './checkoutListTable.container';

export default CheckoutListTable